import ModuleBase, { ViewLayer, moduleInit, bindButtonClickEvent } from "../../../../framework/core/mvvm/module_base";
import BindInviteCodeView from "./bindinvitecode_view";
import AppData from "../../../public/const/app_data";
import ModelData from "../../../public/model_data";
import ModuleManager from "../../../../framework/core/module_manager";
import LanguageManager from "../../../../manager/language_manager";
import EventManager from "../../../../manager/event_manager";
import UserDataManager from "../../../../manager/user_manager";
const { ccclass, property } = cc._decorator;


@ccclass
@moduleInit("BindInviteCode")
export default class BindInviteCode extends ModuleBase<BindInviteCodeView, null> {
    constructor() {
        super();
        this.layer = ViewLayer.Mid;
        this.windowPrefabResPath = "package/club/module/invitecode_table";
        this.viewType = BindInviteCodeView;
        this.modelType = null;
        this.needAnim = true
        this.needViewMask = true
    }

    protected onButtonClickName(name : string) {
        switch (name) {
            case "BackBtn":
                this.hide()
                break;
            case "LeftBtn":
                this.hide()
                break
            case "RightBtn":
                let inviteCode = this.view.inputValue.string
                if (inviteCode.length > 0){
                    if (inviteCode.length == 3 || inviteCode.length == 8 ){
                        this.bindInviteIDCode(inviteCode, ()=>{
                            ModuleManager.instance.destroyModule("BindInviteCode")  
                        })
                    }
                    else{
                        this.bindInviteCode(inviteCode, ()=>{
                            ModuleManager.instance.destroyModule("BindInviteCode")  
                        })
                    }

                }
                else{
                    ModuleManager.instance.toastKey("promote_inputCode")
                }
                break
            default:
                break;
        }
    }


    onShow(intentData) {
        //this.view.inputValue.placeholder = LanguageManager.t("promote_inputCode")
    }


    //绑定id邀请码
    bindInviteIDCode(parentId, callback){
        if (ModelData.instance.roleData.id == parentId) { return }
        let requestData: IHttpRequestData = {
            baseUrl: "promoters/bindParentId?",
            params: {
                parentId:parentId
            }
        }
        this.apiHttpGet(requestData, (retData) => {
            if (callback) {
                callback(retData.data)
                // UserDataManager.clearPlayerDataById(ModelData.instance.roleData.id)
                EventManager.instance.dispatch("event_bind_code")
            }
        })
    }

    //绑定邀请码
    bindInviteCode(inviteCode, callback){
        let requestData: IHttpRequestData = {
            baseUrl: "promoters/bindInviteCode?",
            params: {
                inviteCode:inviteCode
            }
        }
        this.apiHttpGet(requestData, (retData) => {
            if (callback) {
                callback(retData.data)
                // UserDataManager.clearPlayerDataById(ModelData.instance.roleData.id)
                EventManager.instance.dispatch("event_bind_code")
            }
        })
    }

}